import React from "react";
import { default as WButtonBase } from "@mui/material/ButtonBase";

function ButtonBase(props) {
  return <WButtonBase {...props} />;
}

export default ButtonBase;
